// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"vendors-node_modules_analytics_segment_lib_analytics-plugin-segment_browser_es_js-node_module-6ef179":"bf2d5050","src_app_Root_tsx":"2834df56"}[chunkId] + ".chunk.js";
};